export class OrderLoyaltyApplyError extends Error {
    constructor() {
        super('ERROR_ORDER_LOYALTY_FAILED_TO_APPLY');
    }
}
